<template>
  <div ref="list" class="refresh-onscroll-list" @scroll="handleScroll">
    <slot />
    <div v-show="loading" ref="loading" class="refresh-onscroll-list__loading">
      <slot name="loading">
        <span class="h-v-centerer">{{ $t('message.LOADING_DOTS') }}</span>
      </slot>
    </div>
  </div>
</template>

<script>
/**
 * Component used to display a scrollable list of item and trigger an event when reaching the bottom of the list
 * Usage:
 * ```
 *  <RefreshOnscrollList @scrollBottom="refresh">
 *    <div>
 *      <Item v-for="item in items" :key="item.id" />
 *    </div>
 *  </RefreshOnscrollList>
 * ```
 *
 */


import $ from 'jquery';

export default {
  name: 'RefreshOnscrollList',

  props: {
    loading: Boolean,
  },

  data() {
    return {
      threshold: 10,
      insideTriggerZone: false,
    };
  },

  mounted() {
    $(window).on(`resizeEnd.${this.uuid}`, this.checkHeight);
  },

  methods: {
    /** Trigger event when scrolling to bottom */
    handleScroll(e) {
      const listElmt = e.target;
      const loadingElmt = this.$refs.loading;
      const inside = ((listElmt.scrollTop + this.threshold)
        > (listElmt.scrollHeight - loadingElmt.offsetHeight - listElmt.offsetHeight));
      if (!this.insideTriggerZone && inside) {
        // Emit only when entering the trigger zone
        this.$emit('scrollBottom');
      }
      this.insideTriggerZone = inside;
      this.$emit('scroll');
    },
    /** Reset scrollTop to 0 */
    scrollTop() {
      this.$refs.list.scrollTop = 0;
    },
    /** If scrollHeight lesser than container height, trigger event */
    checkHeight() {
      const { list } = this.$refs
      if (!list) return;
      const elt = list.children[0];
      if (elt.scrollHeight <= list.offsetHeight) {
        this.$emit('scrollBottom');
      }
    },
  },
};
</script>

<style lang="scss">
.refresh-onscroll-list {
  overflow: auto;
}

.refresh-onscroll-list__loading {
  padding: 10px 0;
}
</style>
